export default "__VITE_ASSET__f6b61abf__"